import { Controller } from "@hotwired/stimulus"
import "@mapbox/search-js-web"

export default class extends Controller {
  static values = { token: String, proximity: String }
  static targets = ["address1", "address2", "city", "state", "zip"]

  connect() {
    const input = this.address1Target
    const autofill = document.createElement("mapbox-address-autofill")
    autofill.accessToken = this.tokenValue
    if (this.proximityValue) autofill.options = { proximity: JSON.parse(this.proximityValue) }

    input.parentNode.insertBefore(autofill, input)
    autofill.appendChild(input)

    autofill.addEventListener("retrieve", this.handleRetrieve.bind(this))
    this._autofill = autofill
  }

  disconnect() {
    if (this._autofill) {
      const input = this.address1Target
      this._autofill.parentNode.insertBefore(input, this._autofill)
      this._autofill.remove()
      this._autofill = null
    }
  }

  handleRetrieve(event) {
    const feature = event.detail.features[0]
    if (!feature) return
    const props = feature.properties

    if (this.hasAddress2Target) this.address2Target.value = props.address_line2 || ""
    if (this.hasCityTarget) this.cityTarget.value = props.place || ""
    if (this.hasZipTarget) this.zipTarget.value = props.postcode || ""

    if (this.hasStateTarget) {
      const code = props.region_code || ""
      const select = this.stateTarget
      const match = Array.from(select.options).find(o => o.value === code)
      if (match) select.value = code
    }
  }
}
